import React, { useRef } from "react";
import Faq from "../../../../Common/Components/Faq";
import Wsp from "../../../contact/Component/Floatingwsp";
import {
    banner2Data,
  BannerData,
  CarouselData,
  CarouselData1,
  CircleData,
  DetailInfo,
  FaqData,
  IntroData,
  StepData,
  TrimData,
} from "./Data";
import DetailedInfo from "../../../../Common/Components/DetailedInfo";
import MeetTheFamily from "../../../../Common/Components/MeetTheFamily";
import CarouselPart from "../../../../Common/Components/CarouselPart";
import VideoFrame from "../../../../Common/Components/VideoFrame";
import CarStepper from "../../../../Common/Components/CarStepper";
import ShowInterest from "../../../../Common/Container/showintrestCon";
import { Box, Grid } from "@mui/material";
import Banner2 from "../../../../Common/Components/Banner2";
import CarModel from "../../../../Common/Components/CarModel";
import Intro from "../../../../Common/Components/Intro";
import Banner from "../../../../Common/Components/Banner";
import InterestDealer from "../../../../Common/Components/InterestDealer";

export default function CARNIVAL() {
  const showInterestRef = useRef(null);
  return (
    <>
      <Banner bannerData={BannerData} />
          <InterestDealer Intrestdata={"https://www.kia.com/content/dam/kia2/in/en/our-vehicles/carnival/Kia_Carnival_Brochure_Desktop.pdf"} 
          onScrollToInterest={() => {
            if (showInterestRef.current) {
              showInterestRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }}/>
    <Intro data={IntroData} />
    <CarModel
        model="Carnival Limousine+"
        bgCar={
          "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Seltos%2Fint2.mp4?alt=media&token=4111ad1b-e446-42ad-855e-2f81601538a2"
        }
        CircleData={CircleData}
      />
      {/* <Banner2 bannerData={banner2Data} /> */}
      <CarStepper
        StepData={StepData}
        carLink={
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2FC1-E-M.mp4?alt=media&token=3f132d20-377e-4812-9c6f-97d1736e94a1"
        }
        stepTimings={[1.0, 3.0, 5.0, 9.0, 11.0, 13.0]}
      />
      <div ref={showInterestRef}>
        <ShowInterest someValue="Carnival" />
      </div>
      <Grid container>
        <Grid item xs={12}>
          <Box
            component="img" loading="eager" decoding="async"
            src="https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carnival%2Fcarnivalfull001.avif?alt=media&token=5bea4997-991d-4830-a7af-5f3ec2cf421f"
            alt="Image"
            sx={{
              width: "100%",
              height: "auto",
            }}
          />
        </Grid>
      </Grid>
      {CarouselData.map((item) => (
        <CarouselPart data={item} />
      ))}
      {/* <VideoFrame videoUrl="https://youtu.be/5zlAtoY8gko?si=g_nNLrs0oEb5rrD7" /> */}
      {CarouselData1.map((item) => (
        <CarouselPart data={item} />
      ))}
      <MeetTheFamily TrimData={TrimData} data={CircleData} />
      <DetailedInfo DetailInfo={DetailInfo} 
      onScrollToInterest={() => {
        if (showInterestRef.current) {
          showInterestRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }}/>
      <Faq FaqData={FaqData} />
      <Wsp />
    </>
  );
}
